import React, { useState } from "react";
import { View } from "react-native";
import { checkErrors } from "@/Components/Functions/MapFunctions";

export default function JocCheckIn(RouterData: any) {
  const [errors, setErrors] = useState(0);

  const { pregunta, punts } = RouterData.route.params;

  const navigateToReward = () => {
    if (!!pregunta && RouterData.route.params.poi.tipus === "TrivialResum") {
      return RouterData.navigation.replace("Trivial", {
        ...RouterData.route.params,
        poi: RouterData.route.params.poi,
        punts: (punts || 0) + checkErrors(errors),
      });
    }

    RouterData.navigation.replace("Reward", {
      ...RouterData.route.params,
      punts: checkErrors(errors),
    });
  };

  navigateToReward();

  return <View></View>;
}
